import $ from 'jquery';
import i18n, { t }  from '../../i18n/i18n.js';
import View from '../../../controls/View.js';
import MessagePopupView from '../../../controls/MessagePopupView.js';
import app from '../../App.js';

var minuteFields = [
    'idle_duration_alert_minutes',
    'in_call_duration_alert_minutes',
    'dialing_duration_alert_minutes',
    'logged_in_duration_alert_minutes'];

var template = '<table class="edit-table"><tbody>' +
    '<tr><th><label for="edit_idle_duration_alert_minutes">{project_realtime_settings.idle_duration_alert_minutes}</label></th><td><input type="text" data-name="idle_duration_alert_minutes_amount" data-type="numeric-with-units" id="idle_duration_alert_minutes" /><select data-name="idle_duration_alert_minutes_units" data-type="time-plural-units"></select></td></tr>' +
    '<tr><th><label for="edit_in_call_duration_alert_minutes">{project_realtime_settings.in_call_duration_alert_minutes}</label></th><td><input type="text" data-name="in_call_duration_alert_minutes_amount" data-type="numeric-with-units" id="in_call_duration_alert_minutes" /><select data-name="in_call_duration_alert_minutes_units" data-type="time-plural-units"></select></td></tr>' +
    '<tr><th><label for="edit_dialing_duration_alert_minutes">{project_realtime_settings.dialing_duration_alert_minutes}</label></th><td><input type="text" data-name="dialing_duration_alert_minutes_amount" data-type="numeric-with-units" id="dialing_duration_alert_minutes" /><select data-name="dialing_duration_alert_minutes_units" data-type="time-plural-units"></select></td></tr>' +
    '<tr><th><label for="edit_logged_in_duration_alert_minutes">{project_realtime_settings.logged_in_duration_alert_minutes}</label></th><td><input type="text" data-name="logged_in_duration_alert_minutes_amount" data-type="numeric-with-units" id="logged_in_duration_alert_minutes" /><select data-name="logged_in_duration_alert_minutes_units" data-type="time-plural-units"></select></td></tr>' +
    '</tbody></table>';

var ProjectRealTimeSettings = View.extend({

    events: {
        'change input,select,textarea': 'onFieldChange'
    },

    initialize: function (options) {
        var that = this;

        that.options = options = options || {};

        var $scrollPane = that.$scrollPane = $('<div class="scrollable-pane-content">').appendTo($('<div class="scrollable-pane">').appendTo(that.$el));

        $('<h2>').text(t('project_realtime_settings.title')).appendTo($scrollPane);

        var $table = that.$table = $(i18n.processLocalizedString(template)).appendTo($scrollPane);
        $table.find('input[data-type=numeric-with-units]').numeric({ decimal: false });

        $table.find('select[data-type=time-plural-units]').empty().append(
            $('<option>').text(t('time_units.minutes')).val('minutes'),
            $('<option>').text(t('time_units.hours')).val('hours')
        );

        $('<div class="corner-commit-actions">').append(
            $('<button class="action-save-button">').text(t('save')).click(that.saveClicked.bind(that))
        ).appendTo(that.$el);

        if (options.projectId) {
            app.AlertUI.showLoader();

            that.ajaxGet(app.apiUrl('projects/' + encodeURIComponent(options.projectId)),
                { 'fields': [
                        'id',
                        'idle_duration_alert_minutes',
                        'in_call_duration_alert_minutes',
                        'dialing_duration_alert_minutes',
                        'logged_in_duration_alert_minutes'].join(',') }
            )
                .always(function () {
                    app.AlertUI.hideLoader();
                })
                .then(function (data) {

                    that.loadFromData(data);
                })
                .fail(function (xhr, error) {
                    app.showXhrError(xhr, error);
                });
        }

    },

    loadFromData: function (data) {
        var that = this;

        minuteFields.forEach(function (key) {
            var rowValue = data[key];
            if (rowValue) {

                rowValue = parseInt(rowValue, 10);

                var units = (rowValue > 60 && (rowValue % 60) === 0) ? 'hours' : 'minutes';

                var value = units === 'hours' ? (rowValue / 60) : rowValue;

                that.$table.find('input[data-name=' + key + '_amount]').val(value);
                that.$table.find('select[data-name=' + key + '_units]').val(units);

            }
        });

        return that;
    },

    saveClicked: function () {
        var that = this;

        that.$table.find('input.invalid,textarea.invalid,select.invalid').removeClass('invalid');

        var invalid = false;

        var data = {
        };

        minuteFields.forEach(function (key) {
            var val = i18n.parseNumber(that.$table.find('input[data-name=' + key + '_amount]').val());
            var units = that.$table.find('select[data-name=' + key + '_units]').val();

            if (!val) {
                invalid = true;
                that.$table.find('input[data-name=' + key + '_amount]').addClass('invalid');
            } else {
                data[key] = val * (units == 'hours' ? 60 : 1);
            }
        });

        if (invalid) {
            that.$table.find('input.invalid,textarea.invalid,select.invalid').first().focus();
            return;
        }

        var apiUrl = app.apiUrl('projects/' + encodeURIComponent(that.options.projectId));

        app.AlertUI.showLoader(t('activity_indicator.saving'));

        that.ajaxJsonPost(apiUrl, data)
            .always(function () {
                app.AlertUI.hideLoader();
            })
            .then(function (response) {
                that._saveNeeded = false;

                new MessagePopupView({addClass: 'done', message: t('project_realtime_settings.saved_prompt'), queue: true}).show();
            })
            .fail(function (xhr, error) {
                app.showXhrError(xhr, error);
            });

        return that;
    },

    onFieldChange: function () {
        this._saveNeeded = true;
        return this;
    },

    hasUnsavedChanges: function() {
        return this._saveNeeded;
    },

});

export default ProjectRealTimeSettings;
